import React, { useEffect, useState } from "react";
import Logo from "../../../../images/allPayment.png";
import {
  getAllTransactionByDateRange,
  uploadRefundSheet,
} from "../AdminActionCreator.component";
import moment from "moment";
import Loader from "../../../presentationals/Loader/Loader.component";

function AllTransaction() {
  const [fileName, setFileName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [transactionData, setTransactionData] = useState([]);
  const [totalCount, setTotalCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const today = moment().format("YYYY-MM-DD");

  const [date, setDate] = useState({
    from: today,
    to: today,
  });
  const itemsPerPage = 10;
  const totalPages = Math.ceil(Number(totalCount) / Number(itemsPerPage));

  const getALlTransactionByDateFn = () => {
    setLoading(true);
    const sDate = moment(date.from).format("DD-MM-YYYY");
    const eDate = moment(date.to).format("DD-MM-YYYY");

    getAllTransactionByDateRange(
      sDate,
      eDate,
      currentPage,
      itemsPerPage,
      (res) => {
        console.log("fvuds", res);
        setTransactionData(res?.data?.data || res || []);
        setTotalCount(res?.data?.totalCount);
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    getALlTransactionByDateFn();
  }, [currentPage]);

  const csvHandler = (e) => {
    const file = e.target.files[0];

    console.log("file", file);
    if (file) {
      setFileName(file.name);

      uploadRefundSheet(file, (callback) => {
        console.log("Uploaded", callback);
      });
    }
  };

  const handleDateChange = (e) => {
    setCurrentPage(1);
    setDate({ ...date, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Bulk Upload */}
      <h3 style={{ textAlign: "center", color: "#1e3a8a" }}>Initiate Refund</h3>

      <div style={{ maxWidth: "500px", margin: "auto" }}>
        <b>Sample Csv</b>
        <img src={Logo} alt="sample" style={{ width: "100%" }} />

        <br />

        <div style={{ display: "flex", gap: "10px" }}>
          <input
            type="text"
            readOnly
            value={fileName}
            style={{
              flex: 1,
              height: "42px",
              padding: "8px",
              border: "1px solid #ccc",
            }}
          />

          <label style={buttonStyle}>
            Browse
            <input
              type="file"
              style={{ display: "none" }}
              onChange={csvHandler}
            />
          </label>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "15px",
          alignItems: "center",
          marginTop: "30px",
          flexWrap: "wrap",
        }}
      >
        <input
          type="date"
          name="from"
          value={date.from}
          onChange={handleDateChange}
          style={inputStyle}
        />

        <input
          type="date"
          name="to"
          value={date.to}
          onChange={handleDateChange}
          style={inputStyle}
        />

        <button
          onClick={() => {
            setCurrentPage(1);
            getALlTransactionByDateFn();
          }}
          style={{
            padding: "10px 16px",
            backgroundColor: "#16a34a",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Apply Filter
        </button>
      </div>

      {/* Table */}
      <h2 style={{ textAlign: "center", marginTop: "20px" }}>Transactions</h2>

      {loading ? (
        <Loader />
      ) : (
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>Loan ID</th>
              <th style={thStyle}>Transaction Id</th>
              <th style={thStyle}>Refund Amount</th>
              <th style={thStyle}>Refund Date</th>
              <th style={thStyle}>Prepay Amount</th>
              <th style={thStyle}>Prepay Date</th>

              <th style={thStyle}>Mode</th>
              <th style={thStyle}>Status</th>
            </tr>
          </thead>

          <tbody>
            {transactionData?.length > 0 ? (
              transactionData?.map((item) => (
                <tr key={item.id}>
                  <td style={thTd}>{item.id}</td>

                  <td style={thTd}>{item.loanId}</td>
                  <td style={thTd}>{item.transactionId}</td>
                  <td style={thTd}>{item.refundAmount || "-"}</td>
                  <td style={thTd}>{item.refundDate || "-"}</td>
                  <td style={thTd}>{item.prepayAmount || "-"}</td>
                  <td style={thTd}>
                    {item.prepayDate
                      ? moment(item.prepayDate, "DD-MM-YYYY HH:mm").format(
                          "DD-MM-YYYY",
                        )
                      : "-"}
                  </td>

                  <td style={thTd}>{item.paymentMode}</td>
                  <td style={thTd}>{item.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={thTd}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          style={currentPage === 1 ? disabledBtn : buttonStyle}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          Prev
        </button>

        <span style={{ margin: "0 10px" }}>
          Page {currentPage} / {totalPages}
        </span>

        <button
          style={currentPage === totalPages ? disabledBtn : buttonStyle}
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default AllTransaction;

// Styles
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "20px",
};

const thTd = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
  fontSize: "14px",
};

const thStyle = {
  ...thTd,
  backgroundColor: "#f5f5f5",
  fontWeight: "600",
};

const buttonStyle = {
  padding: "6px 12px",
  margin: "5px",
  border: "none",
  cursor: "pointer",
  backgroundColor: "#4f46e5",
  color: "#fff",
  borderRadius: "4px",
};

const disabledBtn = {
  ...buttonStyle,
  backgroundColor: "#ccc",
  cursor: "not-allowed",
};

const inputStyle = {
  padding: "10px 12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  outline: "none",
  fontSize: "14px",
  minWidth: "200px",
  transition: "0.2s",
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
};
